import { render } from "./CardButton.vue?vue&type=template&id=4c0d88cc"
import script from "./CardButton.vue?vue&type=script&lang=js"
export * from "./CardButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__